import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Time Unit", -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", null, "Time Duration", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dt", null, "Status", -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dt", null, "Publish Time", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("dt", null, "Unpublish Time", -1)
const _hoisted_12 = { class: "card-footer bg-white border border-light" }
const _hoisted_13 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Tournament Leaderboard Detail "
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderTimeUnit(_ctx.model.timeUnit)
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.timeDuration), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderStatus(_ctx.model.status)
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.publishTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_11,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.unpublishTime)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.model.canEdit)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 0,
                name: "Edit",
                icon: "fa-edit",
                theme: "info",
                to: { name: _ctx.ROUTE_NAME_TOURNAMENT.LEADERBOARD.EDIT, params: { id: _ctx.model.id } }
              }, null, 8, ["to"]))
            : _createCommentVNode("", true),
          (_ctx.model.canDelete)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 1,
                name: "Delete",
                icon: "fa-trash-alt",
                theme: "danger",
                onClick: _withModifiers(_ctx.actions.remove, ["prevent"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}